module.exports = __webpack_public_path__ + "img/bi.7e980569.svg";